
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <p>Send Assets to K2</p>
    </div>
  </div>
  <div class="row alert-container-block">
    <error [error]="error"></error>
  </div>
  <div class="row alert-container-block" *ngIf="siteDifferences.length">
    <div class="alert alert-warning" style="min-width: 500px;"><span>ERROR: Sites differ between TMC and K2/ACDC</span><span class="float-right">
        <button class="float-right btn btn-outline-secondary" type="button" (click)="viewDifferingSites()">View Differences</button></span></div>
  </div>
  <div class="row" *ngIf="newSiteToBeCreated">
    <div class="alert alert-warning"><span>Warning: New site(s) {{ newSiteToBeCreated }} will be created if the selected assets are uploaded to K2</span></div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filterAssets.length" (onChange)="onListControlsChange($event)">
        <div class="dropdown" [hidden]="disableAll">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);" (click)="sendToK2()">Upload all selected assets</a><a class="dropdown-item" [downloadFile]="'/api/DeploymentWorkflow/export-assets/' + workflowTargetInfo.targetId"><span class="oi oi-cloud-download"></span> Export Manual Design File</a><a class="dropdown-item" [downloadFile]="'/api/DeploymentWorkflow/k2-reconciliation-report/' + workflowTargetInfo.projectId"><span class="oi oi-cloud-download"></span> Export K2 Reconciliation Report</a><a class="dropdown-item" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/sendDevicesToK2/messageToTransitionLeads'"><span class="oi oi-envelope-closed"></span> Send message to transition lead(s)</a><a class="dropdown-item" [downloadFile]="'/api/DeploymentWorkflow/export-deployed-devices-report'" [params]="{deploymentId: workflowTargetInfo.targetId}"><span class="oi oi-cloud-download"></span> Create Deployed Asset Report</a><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAll()">Deselect all</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAll()">Select all</a></div>
        </div>
      </list-controls>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [(ngModel)]="hideCompletedAssets" (change)="onListControlsChange($event)" autoLinkToLabel>
        <label class="form-check-label">Hide assets/removals already in K2</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [(ngModel)]="hideInvalidAssets" (change)="onListControlsChange($event)" autoLinkToLabel>
        <label class="form-check-label">Hide invalid assets</label>
      </div>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th></th>
            <th>SKU</th>
            <th>Model</th>
            <th>Device Key</th>
            <th>Serial Number</th>
            <th>Asset Tag</th>
            <th>Building</th>
            <th>Floor</th>
            <th>Map ID</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let asset of displayAssets; let idx = index;">
            <td>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="asset-selection-checkbox-{{asset.id}}" [(ngModel)]="asset.selectedNew" [hidden]="disableAll || asset.disabled" [disabled]="disableAll || asset.disabled" (change)="updateSelection(asset)">
              </div>
            </td>
            <td>{{ asset.productNumber }}</td>
            <td><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>{{ asset.model }}</span></td>
            <td *ngIf="asset.type === 'asset'">{{ asset.deviceKey }}</td>
            <td class="text-red" *ngIf="asset.type === 'asset removal'">Removal</td>
            <td>{{ asset.serialNumber }}</td>
            <td>{{ asset.assetTag }}</td>
            <td>{{ asset.building }}</td>
            <td>{{ asset.floor }}</td>
            <td>{{ asset.floorMapId }}</td>
            <td>
              <status-indicator [states]="assetStateList" [key]="asset.statusKey" [detail]="asset.statusDetail"></status-indicator>
            </td>
            <td>
              <div class="btn-group">
                <button class="btn btn-outline-primary btn-sm" (click)="edit(asset)" [disabled]="asset.installed || asset.ordered">Edit</button>
              </div>
            </td>
          </tr>
          <tr *ngIf="displayAssets.length === 0">
            <td colspan="8">
              <p class="text-center empty-table-message">There are no un-uploaded assets to display</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>